import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnable3plDashboard = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enable3plDashboard);
};
